import { applyThemeVars } from './applyThemeVars'

function injectFont(url: string) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = url
  document.head.appendChild(link)
}

export async function loadTenant() {
  const url = new URL(window.location.href)
  const tenantId = url.searchParams.get('tenant') || url.hostname.split('.')[0]
  const base = import.meta.env.VITE_TENANT_BASE
  if (!tenantId || !base) return null
  const res = await fetch(`${base}/tenants/${tenantId}`)
  if (!res.ok) return null
  const json = await res.json()
  if (json?.fonts?.cssUrl) injectFont(json.fonts.cssUrl)
  if (json?.theme) applyThemeVars(json.theme)
  return json
}


